import { Phone, Mail } from "lucide-react";
import { CONTACT } from "./NSLogo";

export default function ContactStrip() {
  return (
    <section
      data-testid="global-contact-strip"
      className="bg-[#F5F3EF] border-b border-[#D9D6D0]"
    >
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12 py-5 md:py-6 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-10 items-center">
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.28em] text-[#C17A43]">
            — {CONTACT.parentBrand}
          </p>
          <p className="mt-1.5 font-serif italic text-lg md:text-xl text-[#111111]">
            Reach a licensed supervisor.
          </p>
        </div>
        <a
          href={CONTACT.phoneHref}
          data-testid="global-strip-phone"
          className="group flex items-center gap-4 border-t md:border-t-0 md:border-l md:border-r border-[#D9D6D0] md:px-8 pt-4 md:pt-0 hover:text-[#C17A43] transition-colors"
        >
          <Phone size={18} strokeWidth={1.5} className="text-[#C17A43] flex-shrink-0" />
          <div className="min-w-0">
            <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-[#111111]/60">
              Dispatch · 24/7
            </p>
            <p className="font-serif text-lg md:text-2xl text-[#111111] group-hover:italic transition-[font-style] duration-300">
              {CONTACT.phone}
            </p>
          </div>
        </a>
        <a
          href={CONTACT.emailHref}
          data-testid="global-strip-email"
          className="group flex items-center gap-4 border-t md:border-t-0 border-[#D9D6D0] md:pl-4 pt-4 md:pt-0 hover:text-[#C17A43] transition-colors"
        >
          <Mail size={18} strokeWidth={1.5} className="text-[#C17A43] flex-shrink-0" />
          <div className="min-w-0">
            <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-[#111111]/60">
              Written brief
            </p>
            <p className="font-serif text-lg md:text-2xl text-[#111111] group-hover:italic transition-[font-style] duration-300 break-all">
              {CONTACT.email}
            </p>
          </div>
        </a>
      </div>
    </section>
  );
}
